import { TextField , TextFieldProps } from '@mui/material';
import React from 'react';

const TextFieldWrapper: React.FC<TextFieldProps> = ({ ...props }) => (
  <TextField {...props} />
);

export default TextFieldWrapper;
